import { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  getOfficeStatistics,
  getOfficeStatisticsReport,
} from "../../store/EmployeesSlice";

import Statistics from "../../components/layouts/home/Statistics";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const OfficeStatistics = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { OfficeStatisticsArray, OfficeStatisticsReportArray } = useSelector(
    (state) => state.EmployeesSlice
  );

  useEffect(() => {
    dispatch(getOfficeStatistics(id));
  }, [dispatch, id]);
  useEffect(() => {
    const data = {
      id,
    };
    dispatch(getOfficeStatisticsReport(data));
  }, [dispatch, id]);
  return (
    <div className="Tabel_container">
      <div className=" grid justify-content-evenly  ">
        {/* <div className="col-12 md:col-6 ">
          <div className="cardHero">
            <div className="circle">
              <BsBank />
            </div>
            <h5>جميع الطلبات</h5>
            <h2> {OfficeStatisticsArray?.total_orders}</h2>
          </div>
        </div> */}
        {OfficeStatisticsArray && (
          <div className="col-12 md:col-6">
            <Statistics data={OfficeStatisticsArray?.monthly_data} />
          </div>
        )}
        {OfficeStatisticsReportArray?.appointment_consultations_report?.data
          ?.length > 0 && (
          <div className="col-12 md:col-6">
            <div className="card_info">
              <h3 className="title__">تقرير المواعيد والاستشارات</h3>
              <DataTable
                id="home"
                value={
                  OfficeStatisticsReportArray?.appointment_consultations_report
                    ?.data
                }
                className="dataTable"
                dataKey="id"
                emptyMessage="لا يوجد   بيانات متاحة"
              >
                <Column field="price" header={"السعر"} />
                <Column field="appointment_date" header={"تاريخ التعيين"} />
                <Column field="appointment_time" header={"وقت التعيين"} />
                <Column field="user.name" header={"العميل"} />
              </DataTable>
            </div>
          </div>
        )}
        {OfficeStatisticsReportArray?.contracts_report?.data?.length > 0 && (
          <div className="col-12 md:col-6">
            <div className="card_info">
              <h3 className="title__">تقرير العقود</h3>
              <DataTable
                id="home"
                value={OfficeStatisticsReportArray?.contracts_report?.data}
                className="dataTable"
                dataKey="id"
                emptyMessage="لا يوجد   بيانات متاحة"
              >
                <Column field="pages" header={"الصفح"} />
                <Column field="price" header={"السعر"} />
                <Column field="user.name" header={"العميل"} />
              </DataTable>
            </div>
          </div>
        )}

        {OfficeStatisticsReportArray?.hire_lawyers_report?.data?.length > 0 && (
          <div className="col-12 md:col-6">
            <div className="card_info">
              <h3 className="title__"> تقرير توظيف المحامين</h3>
              <DataTable
                id="home"
                value={OfficeStatisticsReportArray?.hire_lawyers_report?.data}
                className="dataTable"
                dataKey="id"
                emptyMessage="لا يوجد   بيانات متاحة"
              >
                <Column field="price" header={"السعر"} />
                <Column field="appointment_date" header={"تاريخ التعيين"} />
                <Column field="appointment_time" header={"وقت التعيين"} />
                <Column field="user.name" header={"العميل"} />
              </DataTable>
            </div>
          </div>
        )}
        {OfficeStatisticsReportArray?.economic_consultations_report?.data
          ?.length > 0 && (
          <div className="col-12 md:col-6">
            <div className="card_info">
              <h3 className="title__"> تقرير الاستشارات الاقتصادية</h3>
              <DataTable
                id="home"
                value={
                  OfficeStatisticsReportArray?.economic_consultations_report
                    ?.data
                }
                className="dataTable"
                dataKey="id"
                emptyMessage="لا يوجد   بيانات متاحة"
              >
                <Column field="price" header={"السعر"} />
                <Column field="description" header={"التفاصيل"} />

                <Column field="user.name" header={"العميل"} />
              </DataTable>
            </div>
          </div>
        )}
        {OfficeStatisticsReportArray?.private_consultations_report?.data
          ?.length > 0 && (
          <div className="col-12 md:col-6">
            <div className="card_info">
              <h3 className="title__"> تقرير الاستشارات الخاصة</h3>
              <DataTable
                id="home"
                value={
                  OfficeStatisticsReportArray?.private_consultations_report
                    ?.data
                }
                className="dataTable"
                dataKey="id"
                emptyMessage="لا يوجد   بيانات متاحة"
              >
                <Column field="price" header={"السعر"} />
                <Column field="description" header={"التفاصيل"} />

                <Column field="user.name" header={"العميل"} />
              </DataTable>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default OfficeStatistics;
